import { useEffect } from "react"
import { Helmet } from "react-helmet"
import { useParams } from "react-router-dom"
import styled from "styled-components"

import { useLazyGetPublicReferralAgentQuery } from "store/api/publicApi"

import { Faq } from "./Faq"
import { FooterCta } from "./FooterCta"
import { Gift } from "./Gift"
import { Header } from "./Header"
import { Hero } from "./Hero"
import { displayFont, ReferralAgentContext, textDark, textGrey } from "./shared"
import { Steps } from "./Steps"

const Page = styled.div`
  min-height: 100vh;
  background: #f8fafc;
  color: ${textDark};
  font-family: "Inter", sans-serif;

  h1,
  h2,
  h3 {
    margin: 0;
  }
`

const StatusScreen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 60vh;
  padding: 24px;
  text-align: center;

  h1 {
    font-family: ${displayFont};
    font-size: 1.5rem;
  }

  p {
    margin: 0;
    color: ${textGrey};
    font-size: 0.9375rem;
  }
`

export const ReferralLanding = () => {
  const { slug } = useParams<{ slug: string }>()
  const [triggerGetAgent, { data, isLoading, isError, isUninitialized }] = useLazyGetPublicReferralAgentQuery()

  useEffect(() => {
    if (slug) triggerGetAgent(slug)
  }, [slug, triggerGetAgent])

  const agent = data?.data ?? null

  return (
    <Page>
      <Helmet>
        <title>Nuve | Claim your free thermostat</title>
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@600;700&display=swap" rel="stylesheet" />
      </Helmet>
      <Header />
      {isError || !slug ? (
        <StatusScreen>
          <h1>This referral link isn&apos;t active</h1>
          <p>Double-check the link you received, or ask your agent for a new one.</p>
        </StatusScreen>
      ) : isUninitialized || isLoading || !agent ? null : (
        <ReferralAgentContext.Provider value={agent}>
          <Hero />
          <Steps />
          <Gift />
          <Faq />
          <FooterCta />
        </ReferralAgentContext.Provider>
      )}
    </Page>
  )
}
